import { connect } from 'react-redux';
import ManageViewsSidepanel from '../../worklist/components/toolbar/manage-views-sidepanel';
import { updateGanttViews } from '../../common/gantt/containers/gantt-actions';

const mapStateToProps = state => ({
  views: state.gantt.views,
  isLoadingViews: state.gantt.isLoadingViews,
  isSaving: state.gantt.isSavingViews,
  saveSuccess: state.gantt.saveViewsSuccess,
  error: state.gantt.error,
  activeView: state.gantt.activeView,
});

const mapDispatchToProps = {
  updateViews: updateGanttViews,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageViewsSidepanel);
